import type { ReactNode } from "react";

interface Props {
  title: string;
  children: ReactNode;
}

export function NavSection({ title, children }: Props) {
  return (
    <div className="sidebar-nav-section">
      <div className="sidebar-nav-section-title">{title}</div>
      {children}
    </div>
  );
}
